import { contentStateFromString, contentStateToString } from "@utils/richText/converters";
import { MediaDto, mediaFromDto, mediaToDto } from "@domain/media/dtos";
import { Profile } from "./profile";
import { Person, PersonType } from "./user";

export function profileFromDto(dto: ProfileDto): Profile {
	const {
		avatar,
		avatarOriginal,
		banner,
		description,
		followingMeSince,
		followedByMeSince,
		memberSince,
		type,
		presentation,
		insightCount,
		carouselCount,
		quizCount,
		courseCount,
		avatarCrop,
	} = dto;
	return {
		...dto,
		avatar: avatar ? mediaFromDto(avatar) : undefined,
		avatarOriginal: avatarOriginal ? mediaFromDto(avatarOriginal) : undefined,
		avatarCrop: avatarCrop ? mediaFromDto(avatarCrop) : undefined,
		banner: banner ? mediaFromDto(banner) : undefined,
		followingMeSince: followingMeSince && followingMeSince != null ? new Date(followingMeSince) : undefined,
		followedByMeSince: followedByMeSince && followedByMeSince != null ? new Date(followedByMeSince) : undefined,
		memberSince: memberSince ? new Date(memberSince) : undefined,
		description: description ?? "",
		type: type ?? "USER",
		presentation: presentation ? contentStateFromString(presentation) : undefined,
		contentCount: (insightCount ?? 0) + (courseCount ?? 0) + (carouselCount ?? 0) + (quizCount ?? 0),
	};
}

export function profileToDto(profile: Profile): ProfileDto {
	const {
		avatar,
		banner,
		description,
		presentation,
		followingMeSince,
		followedByMeSince,
		memberSince,
		avatarOriginal,
		avatarCrop,
	} = profile;

	return {
		...profile,
		avatar: avatar ? mediaToDto(avatar) : undefined,
		avatarOriginal: avatarOriginal ? mediaToDto(avatarOriginal) : undefined,
		avatarCrop: avatarCrop ? mediaToDto(avatarCrop) : undefined,
		banner: banner ? mediaToDto(banner) : undefined,
		followingMeSince: followingMeSince ? followingMeSince.toISOString() : undefined,
		followedByMeSince: followedByMeSince ? followedByMeSince.toISOString() : undefined,
		memberSince: memberSince ? memberSince.toISOString() : undefined,
		description: description ?? "",
		type: profile.type ?? "USER",
		presentation: presentation && presentation.getPlainText() ? contentStateToString(presentation) : undefined,
	};
}

export interface ProfileDto extends Omit<
	Profile,
	| "description"
	| "followingMeSince"
	| "followedByMeSince"
	| "type"
	| "memberSince"
	| "avatar"
	| "avatarOriginal"
	| "banner"
	| "presentation"
	| "avatarCrop"
> {
	avatar?: MediaDto;
	avatarOriginal?: MediaDto;
	avatarCrop?: MediaDto;
	banner?: MediaDto;
	followingMeSince?: string;
	followedByMeSince?: string;
	memberSince?: string;
	description?: string;
	presentation?: string;
	type?: PersonType;
}

export function personFromDto(dto: PersonDto): Person {
	return {
		...dto,
		avatar: dto.avatar ? mediaFromDto(dto.avatar) : undefined,
		avatarOriginal: dto.avatarOriginal ? mediaFromDto(dto.avatarOriginal) : undefined,
		avatarCrop: dto.avatarCrop ? mediaFromDto(dto.avatarCrop) : undefined,
	};
}

export function personToDto(person: Person): PersonDto {
	return {
		...person,
		avatar: person.avatar ? mediaToDto(person.avatar) : undefined,
		avatarOriginal: person.avatarOriginal ? mediaToDto(person.avatarOriginal) : undefined,
		avatarCrop: person.avatarCrop ? mediaToDto(person.avatarCrop) : undefined,
	};
}

export interface PersonDto extends Omit<Person, "avatar" | "avatarOriginal" | "avatarCrop"> {
	avatar?: MediaDto;
	avatarOriginal?: MediaDto;
	avatarCrop?: MediaDto;
}
